// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width: 1024px) {\n  .box[data-v-5533bd3a] {\n    padding: var(--magic-box-padding, var(--magic-space--large, 32px));\n  }\n}", ""]);
// Exports
module.exports = exports;
